import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Modal extends Component {
  render() {
    return (
      <div>
        <div className="grid">
          <div className="info">
            <h1>404</h1>
            <h5>
            Sorry we couldn't find the page you're looking for.
            </h5>
            <br/>
          <Link className="btn" to="/">Back to Home</Link>
          </div>
        </div>
      </div>
    );
  }
}

export default Modal;


// WEBPACK FOOTER //
// ./src/components/NotFound.js